import React from 'react'

import clsx from 'clsx'

import classes from './Divider.module.scss'

/** @type {import("./types").default} */
const Divider = ({ className }) => {
  return <hr className={clsx('Divider', classes.root, className)} />
}

export default Divider
